<template>
    <!-- IE 2026 09 25 / ODOO-… (замечание Игоря: многострочный диалог описания записи): «Для редактирования описания нужен другой диалог, который позволит
         вносить многострочную часть». Кнопка «Edit description» / «Add description» подсказки по Alt (utils/recordHelp.js editHtml → tipAction_run edithelp →
         recordHelp.edit) открывает этот диалог вместо window.prompt в одну строку: модальное окно в стиле окон подтверждения платформы (App.vue
         .progress-modal / .progress-box / .cinp-btn), телепорт — в корень оверлеев (utils/overlayRoot.js: полноэкранный виджет либо body — виден и в
         Full screen). Шапка — название записи и её сегмент; вкладки языков en / uk / ru (по умолчанию — язык интерфейса), на каждой три МНОГОСТРОЧНЫХ поля
         What it is / Purpose / How to use с автоподгоном высоты; переводы строк сохраняются (бэк режет только края) и видны в подсказке (App.vue:
         .wj-tooltip .ui-help-record { white-space: pre-line }). Заполнение — три вызова record_help (lang en / uk / ru, recordHelp.loadAll); у каждой вкладки
         — откуда текст сейчас (registry = db / код = code / сама запись = record) и status. Поле uk / ru, текст которого совпал с английским, — «перевода нет»:
         бэк показывает английский текст (поле языка, иначе английское) — поле пустое, английский текст серым подсказкой; пустым оно и записывается.
         Save — record_help_save ОДНИМ элементом со ВСЕМИ полями (what / why / how и _uk / _ru, source manual; пустое = снять), затем кэш подсказок языка
         интерфейса — из ответа, прочие ключи той же записи сброшены (recordHelp.saveItem); все поля пустые — подтверждение «Remove the description?» →
         запись с пустыми текстами (архив элемента реестра, как в R1; элемента нет — удалять нечего, так и сказано). Cancel / Esc — закрыть только диалог
         (Esc на window capture с остановкой: App.handleKeydown не закрывает активный виджет; прочие клавиши страницы под модальным окном молчат),
         Ctrl+Enter — сохранить; вторичная ссылка «Open in registry» — прежний переход в форму элемента реестра RECORD-HELP (правки сначала сохраняются;
         элемента ещё нет — создаётся копией показанных текстов). Только админ (recordHelp.canEdit), выключатель прежний — fe.ux.recordHelpEdit.
         Проба — tools/probes/recordhelp_edit_check.mjs; патч — handoff-files/record-help-2026-09-24/p190_rh_dialog.py -->
    <teleport :to="fsRoot || 'body'">
        <div v-if="visible" class="rh-dialog-mask" @mousedown.self="maskDown = true" @click.self="onMaskClick">
            <div ref="box" class="rh-dialog" :class="{ 'rh-dialog-mobile': isMobile }" role="dialog" aria-modal="true" :aria-label="headTitle"
                :data-id="id" :data-segment="segment" @mousedown="maskDown = false">
                <div class="rh-dialog-head">
                    <i class="pi pi-pencil rh-dialog-head-icon"></i>
                    <div class="rh-dialog-head-text">
                        <div class="rh-dialog-title">{{ headTitle }}</div>
                        <div class="rh-dialog-target">
                            <span class="rh-dialog-rec" :title="recTitle">{{ recTitle }}</span>
                            <span v-if="segment" class="rh-dialog-seg" :title="t('Segment')">{{ segment }}</span>
                            <span v-if="id && id !== recTitle" class="rh-dialog-id" :title="t('ID')">{{ id }}</span>
                        </div>
                    </div>
                    <button type="button" class="rh-dialog-x" :title="t('Close') + ' (Esc)'" @click="cancel"><i class="pi pi-times"></i></button>
                </div>
                <div class="rh-dialog-tabs" role="tablist">
                    <button v-for="L in langs" :key="'t' + L.id" type="button" role="tab" class="rh-tab" :class="{ 'is-active': L.id === lang, 'is-dirty': langDirty(L.id) }"
                        :aria-selected="L.id === lang ? 'true' : 'false'" :data-lang="L.id" :title="tabTitle(L)" @click="setLang(L.id)">
                        <span>{{ L.title }}</span><span v-if="langDirty(L.id)" class="rh-tab-dirty">●</span>
                    </button>
                    <span class="rh-tab-spacer"></span>
                    <span v-if="!loading && !loadError" class="rh-src" :data-source="srcOf(lang)" :data-status="statusOf(lang)" :title="srcTitle(lang)">
                        {{ t('Source') }}: <b>{{ srcLabel(lang) }}</b><template v-if="statusOf(lang)"> · {{ statusLabel(lang) }}</template>
                    </span>
                </div>
                <div class="rh-dialog-body">
                    <div v-if="loading" class="rh-dialog-state"><i class="pi pi-spin pi-spinner"></i><span>{{ t('Loading the explanation…') }}</span></div>
                    <div v-else-if="loadError" class="rh-dialog-state rh-dialog-state-err">
                        <span>{{ loadError }}</span>
                        <button type="button" class="cinp-btn cinp-btn-no rh-btn-retry" @click="load">{{ t('Retry') }}</button>
                    </div>
                    <template v-else>
                        <div v-for="L in langs" v-show="L.id === lang" :key="'p' + L.id" class="rh-pane" :data-lang="L.id">
                            <div v-for="f in fields" :key="L.id + f.key" class="rh-field">
                                <label class="rh-field-label" :for="'rh-' + L.id + '-' + f.key">{{ f.label }}</label>
                                <textarea :id="'rh-' + L.id + '-' + f.key" v-model="drafts[L.id][f.key]" class="rh-field-in" :data-lang="L.id" :data-field="f.key"
                                    rows="2" maxlength="4000" :lang="L.id" :placeholder="placeholderOf(L.id, f.key)" :readonly="busy" @input="autosize($event.target)"></textarea>
                            </div>
                            <div v-if="L.id !== 'en'" class="rh-pane-note">{{ t('An empty field shows the English text.') }}</div>
                        </div>
                    </template>
                </div>
                <div v-if="confirmRemove" class="rh-dialog-confirm">
                    <div class="rh-confirm-text">
                        <div class="rh-confirm-title">{{ t('Remove the description?') }}</div>
                        <div class="rh-confirm-note">{{ hasElement
                            ? t('The entry of the «Record help» registry is archived. If the code or the record itself has a text of its own, that text is shown again.')
                            : t('This record has no entry in the «Record help» registry — there is nothing to remove. The text shown now comes from the code or from the record itself and stays.') }}</div>
                    </div>
                    <button ref="backBtn" type="button" class="cinp-btn cinp-btn-no rh-btn-back" @click="removeBack">{{ t('Back') }}</button>
                    <button v-if="hasElement" ref="removeBtn" type="button" class="cinp-btn cinp-btn-yes rh-btn-remove" :disabled="busy" @click="removeConfirmed">
                        <i v-if="busy" class="pi pi-spin pi-spinner"></i> {{ t('Remove') }}</button>
                </div>
                <div v-else class="rh-dialog-foot">
                    <button type="button" class="rh-dialog-link" :disabled="!canOpenRegistry" :title="registryTitle" @click="openRegistry">
                        <i class="pi pi-external-link"></i><span>{{ t('Open in registry') }}</span></button>
                    <span class="rh-foot-spacer"></span>
                    <span v-if="error" class="rh-dialog-err" :title="error">{{ error }}</span>
                    <span v-if="!isMobile" class="rh-foot-hint">{{ t('Ctrl+Enter — save') }}</span>
                    <button type="button" class="cinp-btn cinp-btn-no rh-btn-cancel" @click="cancel">{{ t('Cancel') }}</button>
                    <button type="button" class="cinp-btn rh-btn-save" :disabled="!canSave" :title="canSave ? t('Save (Ctrl+Enter)') : t('Nothing has changed')" @click="save">
                        <i v-if="busy" class="pi pi-spin pi-spinner"></i> {{ t('Save') }}</button>
                </div>
            </div>
        </div>
    </teleport>
</template>

<script>
import { useMainStore } from '@/stores/mainStore'
import { t, getLanguage, LANGUAGES, LANGUAGE_IDS } from '@/i18n'
import { fullscreenEl } from '@/utils/overlayRoot'
import recordHelp from '@/utils/recordHelp'

const FIELDS = ['what', 'why', 'how']
// текст для сравнения и записи: переводы строк — \n, края обрезаны (бэк record_help_save режет края тем же strip)
const norm = (v) => String(v ?? '').replace(/\r\n?/g, '\n').trim()
const emptyDrafts = () => Object.fromEntries(LANGUAGE_IDS.map(L => [L, Object.fromEntries(FIELDS.map(f => [f, '']))]))

export default {
    name: 'RecordHelpDialog',
    setup() {
        const store = useMainStore()
        return { store }
    },
    data: () => ({
        visible: false,
        loading: false,
        loadError: '',
        busy: false,
        error: '',
        confirmRemove: false,
        maskDown: false,
        id: '',
        segment: '',
        argTitle: '',
        startNone: false,       // по кнопке подсказки объяснения нет («Add description») — заголовок до ответа
        lang: 'en',
        entries: {},            // { en, uk, ru }: ответ record_help на языке вкладки | null (объяснения нет)
        base: emptyDrafts(),    // тексты при открытии (после «перевода нет» → '') — с ними сравниваются правки
        drafts: emptyDrafts(),  // правки: drafts[язык][what | why | how]
    }),
    computed: {
        langs() { return LANGUAGES },
        langIds() { return LANGUAGE_IDS },
        uiLang() { const l = getLanguage(); return LANGUAGE_IDS.includes(l) ? l : 'en' },
        fields() {
            return [
                { key: 'what', label: t('What it is') },
                { key: 'why', label: t('Purpose') },
                { key: 'how', label: t('How to use') },
            ]
        },
        isMobile() { return !!this.store.mobileUi?.on },
        fsRoot() { return fullscreenEl() },
        hasAny() { return LANGUAGE_IDS.some(L => !!this.entries[L]) },
        hasElement() { return LANGUAGE_IDS.some(L => this.entries[L]?.source === 'db') },
        headTitle() { return (this.loading ? !this.startNone : this.hasAny) ? t('Edit description') : t('Add description') },
        recTitle() { return norm(this.entries[this.uiLang]?.title || this.entries.en?.title || this.argTitle || this.id) },
        dirty() { return LANGUAGE_IDS.some(L => this.langDirty(L)) },
        allEmpty() { return LANGUAGE_IDS.every(L => FIELDS.every(f => !norm(this.drafts[L][f]))) },
        ready() { return this.visible && !this.loading && !this.loadError },
        canSave() { return this.ready && !this.busy && this.dirty },
        canOpenRegistry() { return this.ready && !this.busy && (this.dirty ? !this.allEmpty : (this.hasElement || !this.allEmpty)) },
        registryTitle() {
            if (!this.canOpenRegistry) return t('Nothing to open yet: write the explanation first.')
            if (this.dirty) return t('Save the changes and open this explanation as a record of the «Record help» registry (status, review).')
            if (!this.hasElement) return t('Copy this explanation into the «Record help» registry and open it there as a record (status, review).')
            return t('Open this explanation as a record of the «Record help» registry (status, review).')
        },
    },
    methods: {
        t,
        // target: { id, segment, title } — из кнопки подсказки (recordHelp.edit)
        open(target) {
            const id = String(target?.id ?? '')
            if (!id) return false
            this.id = id
            this.segment = String(target?.segment ?? '')
            this.argTitle = String(target?.title || '')
            this.startNone = recordHelp.state(id, this.segment) === 'none'
            this.lang = this.uiLang
            this.entries = {}
            this.base = emptyDrafts()
            this.drafts = emptyDrafts()
            this.error = ''
            this.loadError = ''
            this.confirmRemove = false
            this.busy = false
            this.maskDown = false
            if (!this.visible) {
                try { const a = document.activeElement; this._prevFocus = (a && a !== document.body) ? a : null } catch (e) { this._prevFocus = null }
            }
            this.visible = true
            this._listen(true)
            this.load()
            return true
        },
        // три вызова record_help (en / uk / ru); ответ позже закрытия / нового открытия отбрасывается
        async load() {
            const token = (this._loadToken = (this._loadToken || 0) + 1)
            this.loading = true
            this.loadError = ''
            this.error = ''
            const r = await recordHelp.loadAll(this.id, this.segment, LANGUAGE_IDS)
            if (token !== this._loadToken || !this.visible) return
            this.loading = false
            if (!r.ok) {
                this.loadError = r.error === 'no-method' ? t('Record help is not available on this server') : t('Could not load the explanation: {error}', { error: String(r.error || '') })
                return
            }
            this.entries = r.entries
            const base = emptyDrafts(), drafts = emptyDrafts()
            for (const L of LANGUAGE_IDS) for (const f of FIELDS) {
                let v = norm(r.entries[L]?.[f])
                // перевода нет: бэк отдал английский текст (поле языка, иначе английское) — поле пустое, английский текст виден подсказкой; пустым и записывается
                if (L !== 'en' && v && v === norm(r.entries.en?.[f])) v = ''
                base[L][f] = v
                drafts[L][f] = v
            }
            this.base = base
            this.drafts = drafts
            this.$nextTick(() => { this.autosizeAll(); this.focusFirst() })
        },
        langDirty(L) { return FIELDS.some(f => norm(this.drafts[L]?.[f]) !== (this.base[L]?.[f] || '')) },
        tabTitle(L) {
            const parts = [L.title]
            if (L.id === this.uiLang) parts.push(t('Your language'))
            if (this.langDirty(L.id)) parts.push(t('Unsaved changes'))
            return parts.join(' · ')
        },
        setLang(L) {
            if (!LANGUAGE_IDS.includes(L)) return
            this.lang = L
            this.$nextTick(() => this.autosizeAll())
        },
        hint(f) {
            switch (f) {
                case 'what': return t('What the record is — one or two sentences.')
                case 'why': return t('Why it exists: what it is used for, what depends on it.')
                default: return t('How to use it: where it is shown, what to click, what it affects.')
            }
        },
        // uk / ru: пустое поле показывает английский текст — он и есть подсказка поля; нет и его — пояснение, что писать
        placeholderOf(L, f) {
            const en = L !== 'en' ? norm(this.drafts.en[f]) : ''
            return en || this.hint(f)
        },
        srcOf(L) { const s = this.entries[L]?.source; return ['db', 'code', 'record'].includes(s) ? s : 'none' },
        statusOf(L) { const s = this.entries[L]?.status; return ['draft', 'reviewed'].includes(s) ? s : '' },
        srcLabel(L) {
            switch (this.srcOf(L)) {
                case 'db': return t('«Record help» registry')
                case 'code': return t('Built-in text (code)')
                case 'record': return t('Description of the record itself')
                default: return t('No explanation yet')
            }
        },
        srcTitle(L) {
            switch (this.srcOf(L)) {
                case 'db': return t('The text is kept in the «Record help» registry of this database.')
                case 'code': return t('The text is built into the platform code. Saving copies it into the «Record help» registry, where it is edited from then on.')
                case 'record': return t('The text is taken from the record itself (its description or tooltip). Saving copies it into the «Record help» registry, where it is edited from then on.')
                default: return t('This record has no explanation yet — write one and save.')
            }
        },
        statusLabel(L) { return this.statusOf(L) === 'reviewed' ? t('Reviewed') : t('Draft') },
        // элемент record_help_save: все поля всех языков (пустое = снять поле; у uk / ru тогда показывается английский текст)
        _textsInto(item) {
            for (const L of LANGUAGE_IDS) for (const f of FIELDS) item[recordHelp.field(f, L)] = norm(this.drafts[L][f])
            return item
        },
        save() {
            if (!this.ready || this.busy) return
            if (!this.dirty) { this.hide(); return }
            if (this.allEmpty) {
                this.confirmRemove = true
                this.$nextTick(() => { try { (this.$refs.removeBtn || this.$refs.backBtn)?.focus() } catch (e) { /* кнопки нет */ } })
                return
            }
            this.commit(false)
        },
        removeBack() {
            this.confirmRemove = false
            this.$nextTick(() => this.focusFirst())
        },
        removeConfirmed() {
            if (!this.hasElement) { this.removeBack(); return }
            this.commit(false)
        },
        // запись одним элементом со всеми полями (source manual); openAfter — затем форма элемента реестра
        async commit(openAfter) {
            if (this.busy) return
            this.busy = true
            this.error = ''
            const s = await recordHelp.saveItem(this._textsInto({ id: this.id, segment: this.segment, source: 'manual' }))
            this.busy = false
            if (!this.visible) return
            if (!s.ok) {
                this.confirmRemove = false
                this.error = s.error === 'no-method' ? t('Record help is not available on this server') : t('Could not save the description: {error}', { error: String(s.error || '') })
                return
            }
            const removed = s.res.result === 'archived'
            const text = s.nothing ? t('Nothing to save: the «Record help» registry has no entry for this record') : (removed ? t('Description removed') : t('Description saved'))
            try { this.store.show_notification({ text, status: s.nothing ? 'warning' : 'success' }) } catch (e) { /* без уведомлений */ }
            this.hide()
            if (openAfter && !s.nothing && !removed && s.res.id) recordHelp.openForm(s.res.id)
        },
        // «Open in registry»: правки — сначала записать; без правок элемент есть — только его id (тексты не трогаются, source не меняется);
        // элемента нет — создаётся копией показанных текстов (как прежний переход)
        async openRegistry() {
            if (!this.canOpenRegistry) return
            if (this.dirty) { this.commit(true); return }
            this.busy = true
            this.error = ''
            const item = { id: this.id, segment: this.segment }
            if (!this.hasElement) this._textsInto(item)
            const s = await recordHelp.saveItem(item)
            this.busy = false
            if (!this.visible) return
            if (!s.ok || s.nothing || !s.res.id) {
                this.error = s.ok ? t('Could not open the explanation of the record: {error}', { error: t('there is no explanation yet — write it first') })
                    : (s.error === 'no-method' ? t('Record help is not available on this server') : t('Could not open the explanation of the record: {error}', { error: String(s.error || '') }))
                return
            }
            this.hide()
            recordHelp.openForm(s.res.id)
        },
        cancel() { if (!this.busy) this.hide() },
        hide() {
            if (!this.visible) return
            this.visible = false
            this.confirmRemove = false
            this.busy = false
            this.loading = false
            this._loadToken = (this._loadToken || 0) + 1
            this._listen(false)
            const pf = this._prevFocus
            this._prevFocus = null
            try { if (pf && pf.isConnected && typeof pf.focus === 'function' && !(pf.closest && pf.closest('.wj-tooltip'))) pf.focus({ preventScroll: true }) } catch (e) { /* фокус не вернуть */ }
        },
        onMaskClick() {
            const down = this.maskDown
            this.maskDown = false
            if (!down) return
            // клик мимо окна закрывает только без правок — набранный текст не теряется (закрытие с правками — Cancel / Esc / крестик)
            if (!this.dirty && !this.busy) this.hide()
            else this.focusFirst()
        },
        // ---- клавиатура: window capture — раньше App.handleKeydown (document capture) и прочих горячих клавиш страницы ----
        _onKey(e) {
            if (!this.visible) return
            const box = this.$refs.box
            const inside = !!(box && e.target && typeof box.contains === 'function' && box.contains(e.target))
            if (e.key === 'Escape') {
                e.preventDefault(); e.stopImmediatePropagation()
                if (this.busy) return   // идёт запись — окно закроется по ответу
                if (this.confirmRemove) this.removeBack()
                else this.cancel()
                return
            }
            if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) {
                e.preventDefault(); e.stopImmediatePropagation()
                if (this.confirmRemove) this.removeConfirmed()
                else this.save()
                return
            }
            if (e.key === 'Tab') { e.stopImmediatePropagation(); this._trapTab(e); return }
            if (e.key === 'Alt' || e.key === 'Control' || e.key === 'Shift' || e.key === 'Meta') return   // одиночные модификаторы — как были (подсказки по Alt)
            e.stopImmediatePropagation()   // горячие клавиши страницы под модальным окном молчат; набор текста в полях — штатный
            if (!inside) { e.preventDefault(); this.focusFirst() }
        },
        _focusables() {
            const box = this.$refs.box
            if (!box) return []
            return [...box.querySelectorAll('button:not([disabled]), textarea:not([disabled])')].filter(el => el.offsetParent !== null && !el.classList.contains('rh-field-mirror'))
        },
        _trapTab(e) {
            const els = this._focusables()
            if (!els.length) { e.preventDefault(); return }
            const i = els.indexOf(document.activeElement)
            if (i < 0) { e.preventDefault(); els[0].focus(); return }
            if (e.shiftKey && i === 0) { e.preventDefault(); els[els.length - 1].focus() }
            else if (!e.shiftKey && i === els.length - 1) { e.preventDefault(); els[0].focus() }
        },
        focusFirst() {
            const box = this.$refs.box
            if (!box) return
            const ta = [...box.querySelectorAll(`.rh-pane[data-lang="${this.lang}"] textarea.rh-field-in`)].find(el => el.offsetParent !== null && !el.disabled)
            const el = ta || this._focusables()[0]
            if (!el) return
            try {
                el.focus({ preventScroll: true })
                if (el.tagName === 'TEXTAREA') { const n = el.value.length; el.setSelectionRange(n, n) }
            } catch (e) { /* нет фокуса */ }
        },
        // ---- высота полей по тексту (или по подсказке-английскому тексту у пустого поля), 2…14 строк, дальше прокрутка ----
        _mirrorEl() {
            let m = this._mirror
            const box = this.$refs.box
            if (!box) return null
            if (!m || !box.contains(m)) {
                m = document.createElement('textarea')
                m.className = 'rh-field-in rh-field-mirror'
                m.setAttribute('aria-hidden', 'true')
                m.tabIndex = -1
                m.disabled = true
                box.appendChild(m)
                this._mirror = m
            }
            return m
        },
        autosize(el) {
            if (!el || el.tagName !== 'TEXTAREA' || el.offsetParent === null) return
            const cs = getComputedStyle(el)
            const lh = parseFloat(cs.lineHeight) || 19
            const pad = (parseFloat(cs.paddingTop) || 0) + (parseFloat(cs.paddingBottom) || 0)
            const brd = (parseFloat(cs.borderTopWidth) || 0) + (parseFloat(cs.borderBottomWidth) || 0)
            const min = Math.round(lh * 2 + pad + brd), max = Math.round(lh * 14 + pad + brd)
            let sh
            if (!el.value && el.placeholder) {
                // пустое поле: высота по подсказке (английский текст uk / ru бывает в несколько строк) — замер зеркалом, значение поля не трогаем (история правки)
                const m = this._mirrorEl()
                if (m) { m.style.width = el.offsetWidth + 'px'; m.value = el.placeholder; sh = m.scrollHeight }
            }
            if (sh === undefined) { el.style.height = 'auto'; sh = el.scrollHeight }
            const h = Math.min(Math.max(sh + brd, min), max)
            el.style.height = h + 'px'
            el.style.overflowY = sh + brd > max ? 'auto' : 'hidden'
        },
        autosizeAll() {
            const box = this.$refs.box
            if (!box) return
            for (const ta of box.querySelectorAll('textarea.rh-field-in:not(.rh-field-mirror)')) this.autosize(ta)
        },
        _listen(on) {
            if (on) {
                if (this._listening) return
                this._listening = true
                this._onResize = () => { if (this.visible) this.autosizeAll() }
                window.addEventListener('resize', this._onResize)
            } else {
                if (!this._listening) return
                this._listening = false
                window.removeEventListener('resize', this._onResize)
            }
        },
    },
    mounted() {
        // один на приложение: recordHelp.edit открывает его; клавиши — window capture (слушатель ставится раньше слушателей App.mounted)
        this._keyHandler = (e) => this._onKey(e)
        window.addEventListener('keydown', this._keyHandler, true)
        recordHelp.dialog = this
    },
    beforeUnmount() {
        window.removeEventListener('keydown', this._keyHandler, true)
        this._listen(false)
        if (recordHelp.dialog === this) recordHelp.dialog = null
    },
}
</script>

<style>
/* IE 2026 09 25 / ODOO-… (замечание Игоря: многострочный диалог описания записи): вид — как окно подтверждения платформы (App.vue .progress-modal /
   .progress-box / .confirm-input-*, кнопки .cinp-btn); акцент — переменная гаммы --cs-accent. Стили не scoped: окно живёт в корне оверлеев (teleport) */
.rh-dialog-mask { position: fixed; inset: 0; z-index: 20000; display: flex; align-items: center; justify-content: center; background: rgba(0, 0, 0, .4); }
.rh-dialog { position: relative; display: flex; flex-direction: column; width: min(780px, calc(100vw - 32px)); max-height: calc(100vh - 32px); box-sizing: border-box;
    background: #fff; border-radius: 6px; box-shadow: 0 6px 28px rgba(0, 0, 0, .25); color: #333; font-size: 13px; overflow: hidden; }
.rh-dialog-mobile { width: calc(100vw - 16px); max-height: calc(100vh - 16px); }
.rh-dialog-head { display: flex; align-items: flex-start; gap: 10px; padding: 18px 20px 10px 24px; }
.rh-dialog-head-icon { color: var(--cs-accent, #647eff); font-size: 1.15rem; margin-top: 5px; }
.rh-dialog-head-text { flex: 1 1 auto; min-width: 0; }
.rh-dialog-title { font-size: 1.25rem; font-weight: 600; line-height: 1.3; }
.rh-dialog-target { display: flex; align-items: center; gap: 8px; margin-top: 4px; min-width: 0; }
.rh-dialog-rec { font-weight: 600; color: var(--cs-accent, #647eff); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; min-width: 0; }
.rh-dialog-seg { flex: 0 0 auto; font-size: 11px; line-height: 16px; padding: 0 7px; border-radius: 8px; background: #eef2ff; color: #4a5bd4; letter-spacing: .02em; }
.rh-dialog-id { flex: 0 1 auto; min-width: 0; font-size: 11px; color: #6c757d; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.rh-dialog-x { flex: 0 0 auto; border: none; background: transparent; color: #6c757d; cursor: pointer; padding: 5px 6px; border-radius: 4px; }
.rh-dialog-x:hover { color: #d9534f; background: #fdeeee; }
.rh-dialog-tabs { display: flex; align-items: flex-end; gap: 2px; padding: 0 24px; border-bottom: 1px solid #dee2e6; min-width: 0; }
.rh-tab { border: none; border-bottom: 2px solid transparent; margin-bottom: -1px; background: transparent; padding: 7px 12px 6px; font: inherit; font-size: 13px;
    color: #6c757d; cursor: pointer; display: inline-flex; align-items: center; gap: 5px; white-space: nowrap; }
.rh-tab:hover { color: #333; }
.rh-tab.is-active { color: var(--cs-accent, #647eff); border-bottom-color: var(--cs-accent, #647eff); font-weight: 600; }
.rh-tab-dirty { color: var(--cs-accent, #647eff); font-size: 9px; }
.rh-tab-spacer { flex: 1 1 auto; }
.rh-src { flex: 0 1 auto; min-width: 0; font-size: 11px; color: #6c757d; padding: 0 0 8px 8px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.rh-src b { font-weight: 600; color: #495057; }
.rh-dialog-body { flex: 1 1 auto; min-height: 120px; overflow: auto; padding: 12px 24px 4px; }
.rh-field { display: flex; flex-direction: column; gap: 5px; margin-bottom: 12px; }
.rh-field-label { font-size: .85rem; font-weight: 600; color: #6c757d; }
.rh-field-in { display: block; width: 100%; box-sizing: border-box; resize: none; padding: 7px 10px; border: 1px solid #b9c8dd; border-radius: 5px; font: inherit;
    font-size: 13px; line-height: 1.45; color: inherit; background: #fff; overflow-y: hidden; }
.rh-field-in:focus { outline: none; border-color: var(--cs-accent, #647eff); box-shadow: 0 0 0 2px rgba(100, 126, 255, .2); }
.rh-field-in::placeholder { color: #8a8f98; font-style: italic; opacity: 1; }
.rh-field-in[readonly] { background: #f7f8fa; }
.rh-field-mirror { position: absolute; left: -9999px; top: 0; height: 0 !important; min-height: 0 !important; visibility: hidden; pointer-events: none; }
.rh-pane-note { font-size: 11px; color: #6c757d; margin: -4px 0 8px; }
.rh-dialog-state { display: flex; align-items: center; gap: 10px; padding: 26px 0; color: #495057; }
.rh-dialog-state-err { color: #d9534f; flex-wrap: wrap; }
.rh-dialog-foot, .rh-dialog-confirm { display: flex; align-items: center; gap: 10px; padding: 10px 20px 16px 24px; flex-wrap: wrap; }
.rh-dialog-link { border: none; background: transparent; color: var(--cs-accent, #647eff); cursor: pointer; font: inherit; font-size: 12px; padding: 4px 2px;
    display: inline-flex; align-items: center; gap: 5px; }
.rh-dialog-link span { text-decoration: underline; text-underline-offset: 2px; }
.rh-dialog-link:disabled { color: #a0a6b1; cursor: default; }
.rh-dialog-link:disabled span { text-decoration: none; }
.rh-foot-spacer { flex: 1 1 auto; }
.rh-foot-hint { font-size: 11px; color: #8a8f98; white-space: nowrap; }
.rh-dialog-err { color: #d9534f; font-size: 12px; max-width: 360px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.rh-dialog .cinp-btn { display: inline-flex; align-items: center; gap: 6px; font-size: 13px; }
.rh-btn-save { background: var(--cs-accent, #647eff); color: #fff; }
.rh-btn-save:hover:not(:disabled) { filter: brightness(.93); }
.rh-dialog .cinp-btn:disabled { opacity: .5; cursor: default; }
.rh-dialog-confirm { border-top: 1px solid #f1d4d4; background: #fff7f7; }
.rh-confirm-text { flex: 1 1 320px; min-width: 0; }
.rh-confirm-title { font-weight: 600; font-size: 14px; color: #b33636; }
.rh-confirm-note { font-size: 12px; color: #6c757d; margin-top: 2px; line-height: 1.4; }
</style>
